import EventBus from "../event/event-bus";

export default {
  install (Vue) {
    Vue.$bus = Vue.prototype.$bus = EventBus;
  }
};
